import * as React from 'react';
import { StyleSheet } from 'react-native';
import { Button, Dialog, Portal } from 'react-native-paper';
import i18n from 'i18n-js';

import { ActionIcon } from './icon';
import Filter, { empty } from '../constants/filter';
import Datagram from './datagram';
import { View } from './themed-view';
import Sequence from '../constants/sequence';

export interface Props {
  visible: boolean;
  value: Filter;
  setValue: (filter: Filter) => void;
  onDismiss: () => void;
  sequence: Sequence;
}

const styles = StyleSheet.create({
  container: {
    // flex: 1,
    // flexDirection: 'column',
    backgroundColor: '#ff808026'
    // alignItems: 'center',
    // justifyContent: 'space-around'
  }
});

// @todo consider Snackbar instead of HelperText

const FilterDialog = (props: Props) => {
  const { value, setValue, visible, onDismiss, sequence } = props;

  const setFilter = (filter: Filter) => {
    const newFilter: Filter = {
      type: 'Lines',
      lines: Array.from({ length: 6 }, (v, k) => filter.lines[k])
    };
    setValue(newFilter);
  };

  const onChoose = () => setFilter({ type: 'Lines', lines: value.lines });

  const onRemove = () => {
    setFilter(empty());
    onDismiss(); // @todo Preferrably just setFilter to let continue editing
    // @todo @issue filter Datagram is not refreshing after removing, onDismiss as workaround
  };

  return (
    <Portal>
      <Dialog visible={visible} onDismiss={onDismiss}>
        <Dialog.Title>{i18n.t('Lines filter')}</Dialog.Title>
        <Dialog.Content>
          <View style={styles.container}>
            <Datagram
              lines={value.lines}
              choosing
              onChoose={onChoose}
              sequence={sequence}
            />
          </View>
        </Dialog.Content>
        <Dialog.Actions>
          <Button onPress={onRemove}>
            <ActionIcon name="filter-remove-outline" />
          </Button>
          <Button onPress={onDismiss}>{i18n.t('Ok')}</Button>
        </Dialog.Actions>
      </Dialog>
    </Portal>
  );
};

export default FilterDialog;
